module.exports = __webpack_public_path__ + "assets/webgl/Frame_Ornament_base.1001.jpg.etc.cd652f59.ktx";